import { lazy, Suspense } from 'react';
import { Route } from 'react-router-dom';

import Loading from '../../components/Loading';

import accountRouter from '../account';

const RealTimePublicAnnouncementPageComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "public-announcement-page" */ '../../pages/realtime-public-announcement'
    ),
);

const RealTimePublicAnnouncementRecordComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "public-announcement-page" */ '../../pages/realtime-public-announcement/record/AnnouncemnetRecordDialog'
    ),
);

const RealTimePaRecordComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "public-announcement-page" */ '../../pages/realtime-public-announcement/record/RealTimePaRecordDialog'
    ),
);

const RealTimePublicAnnouncementManagementComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "public-announcement-page" */ '../../pages/realtime-public-announcement/management/PublicAnnouncementManagement'
    ),
);

const RealTimePublicAnnouncementScheduleManagementComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "public-announcement-page" */ '../../pages/realtime-public-announcement/schedule/ScheduleManagement'
    ),
);

const publicAnnouncementRouter = (
  <Route path="public-announcement">
    <Route
      path=":projectId"
      element={
        <Suspense fallback={<Loading />}>
          <RealTimePublicAnnouncementPageComponent />
        </Suspense>
      }
    >
      {accountRouter()}
      <Route
        path="record/:recordId"
        element={
          <Suspense fallback={<Loading />}>
            <RealTimePublicAnnouncementRecordComponent />
          </Suspense>
        }
      />
      <Route
        path="record/realtime/:recordId"
        element={
          <Suspense fallback={<Loading />}>
            <RealTimePaRecordComponent />
          </Suspense>
        }
      />
    </Route>
    <Route
      path=":projectId/management"
      element={
        <Suspense fallback={<Loading />}>
          <RealTimePublicAnnouncementManagementComponent />
        </Suspense>
      }
    />
    <Route
      path=":projectId/management-schedule"
      element={
        <Suspense fallback={<Loading />}>
          <RealTimePublicAnnouncementScheduleManagementComponent />
        </Suspense>
      }
    />
  </Route>
);

export default publicAnnouncementRouter;
